import { resolveAuthLayoutRedirect } from "@/lib/auth-redirects";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  component: () => <AuthLayout />,
  beforeLoad: ({ context, location }) => {
    const result = resolveAuthLayoutRedirect({
      searchStr: location.searchStr,
      session: context.stytchSession,
      user: context.user,
      pathname: location.pathname,
    });

    if (!result) return;

    if (result.to === "/impersonate") {
      throw redirect({
        to: "/impersonate",
        state: { impersonationToken: result.impersonationToken },
      });
    }

    throw redirect({ to: result.to });
  },
});

function AuthLayout() {
  return <Outlet />;
}
